import React from "react";
import HelpMessage from "components/util/helpers/HelpMessage";
import l from "components/util/l";
import "styles/css/util/schema_form/TextImprovement.css";


const TextImprovementView = ({
  children,
  disabled,
  isLoading,
  onClickImprove,
}) => (
  <div className="position-relative text-improvement">
    {children}
    {!disabled &&
      <HelpMessage
        forceShow={true}
        message={l("Mejorar redacción%SCW11")}
        style={{ marginTop: "-10px" }}>
        <button
          type="button"
          className="btn btn-sm btn-white position-absolute animate__animated animate__fadeIn animate__faster"
          disabled={disabled || isLoading}
          title={l("Mejorar redacción%SCW11")}
          style={{ bottom: "0.25rem", right: "0.25rem", zIndex: 2, borderColor: "#e7eaf3", color: "#90959a" }}
          onClick={onClickImprove}
        >
          <i className={isLoading ? "fas fa-spinner fa-spin" : "fas fa-wand-magic-sparkles"} />
        </button>
      </HelpMessage>}
  </div>
);

export default TextImprovementView;
